import React, { Component, useState, useRef } from "react";
import { Dropdown } from "react-bootstrap";

import ChatList from "./ChatList";
import Aux from "../../../../../hoc/_Aux";
import DEMO from "../../../../../store/constant";
import PopupInfouser from "../../../../../Demo/PopupInfouser";
import Modal from "../../../../Modal";

import Avatar1 from "../../../../../assets/images/user/avatar-1.jpg";
import Avatar2 from "../../../../../assets/images/user/avatar-2.jpg";
import Avatar3 from "../../../../../assets/images/user/avatar-3.jpg";
import imgBell from "../../../../../assets/images/icons/ic-bell.svg";
import userinfoImg from "../../../../../assets/images/icons/ic-user.svg";
import logoutImg from "../../../../../assets/images/icons/ic-logout.svg";
import downImg from "../../../../../assets/images/icons/ic_chevron_down.svg";

class NavRight extends Component {
  state = {
    listOpen: false,
    isModalOpen: false, // 모달 열림 상태를 추가
  };
  // 모달 열기 함수
  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  // 모달 닫기 함수
  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  // 로그아웃 함수
  logoutHandler = () => {
    window.sessionStorage.removeItem("userInfo");
    window.sessionStorage.removeItem("Token");
    window.sessionStorage.removeItem("tokenLogin");
    window.sessionStorage.removeItem("adminLv");
    window.sessionStorage.removeItem("route");
    window.location.href = "/";
  };

  render() {
    const userName = JSON.parse(
      window.sessionStorage.getItem("userInfo")
    ).UserName;

    //popup
    const userinfoPop = () => {
      const PopupInfouser = document.querySelector("#PopupInfouser");
      const blackBg = document.querySelector(".black_bg");
      const popupBox = document.querySelector(".black_bg .Popup_box");
      PopupInfouser.style.display = "block";
      blackBg.style.display = "block";
      popupBox.style.display = "block";
    };
    return (
      <Aux>
        <Modal isOpen={this.state.isModalOpen} setIsOpen={this.closeModal}>
          <PopupInfouser />
        </Modal>
        <ul className="navbar-nav ml-auto">
          <li>
            <Dropdown alignRight={!this.props.rtlLayout}>
              <Dropdown.Toggle variant={"link"} id="dropdown-basic">
                {/* <i className="icon feather icon-bell" /> */}
                <span className="pcoded-micon">
                  <img src={imgBell} alt="bell" />
                  <div className="alarm">0</div>
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight className="notification">
                <div className="notification_box new_report">
                  <span className="circle"></span>
                  <a href="#!">There is a new report.</a>
                </div>
                <div className="notification_box new_inquiry">
                  <span className="circle"></span>
                  <a href="#!">There is a new inquiry.</a>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          <li>
            <Dropdown alignRight={!this.props.rtlLayout} className="drp-user">
              <Dropdown.Toggle variant={"link"} id="dropdown-basic">
                <span className="userinfoname">{userName}</span>
                <img src={downImg} alt="ic_chevron_down" />
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight className="profile-notification">
                <ul className="pro-body">
                  <li>
                    <a
                      id="userInfopop"
                      className="dropdown-item"
                      // onClick={userinfoPop}
                      onClick={this.openModal}
                    >
                      <img src={userinfoImg} alt="ic-user" />
                      <span> My Info.</span>
                    </a>
                  </li>
                  <li>
                    <a
                      // href={DEMO.BLANK_LINK}
                      onClick={this.logoutHandler}
                      className="dud-logout"
                      title="Logout"
                    >
                      <img src={logoutImg} alt="ic-logout" />
                      <span>Logout</span>
                    </a>
                  </li>
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          </li>
        </ul>
        <ChatList
          listOpen={this.state.listOpen}
          closed={() => {
            this.setState({ listOpen: false });
          }}
        />
      </Aux>
    );
  }
}

export default NavRight;
